import { loader } from 'graphql.macro';

import { ClientSummaryNode } from '../../../../generated/webapp_gql';

export const PROVIDER_AVAILABILITY_QUERY = loader('../documents/ProviderAvailabilityQuery.gql');

export const NO_SESSIONS_ERROR_MSG = `Client doesn't have any remaining therapy sessions. To follow up, send a chat message.`;
export const NOT_HPI_ELIGIBLE_ERROR_MSG = `Client is not eligible for HPI therapy sessions. To follow up, send a chat message.`;

// Times are given in string format, unspecified timezone (it's UTC)
export interface ProviderAvailability {
  end: string;
  start: string;
}

export interface ProviderAvailabilityQuery {
  hasCalendarSetup: boolean;
  providerAvailabilityForProvider?: ProviderAvailability[];
}

export interface SessionDetails {
  endTime: Date;
  member: ClientSummaryNode;
  sessionState?: string | null;
  sessionUuid: string;
  startTime: Date;
  sessionDuration?: number;
}
